export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  ApiService: Symbol('ApiService'),
  SessionVerificationApiService: Symbol('SessionVerificationApiService'),
  SessionVerificationStore: Symbol('SessionVerificationStore'),
  TeamStore: Symbol('TeamStore'),
  SessionPlayStore: Symbol('SessionPlayStore'),
  UiStore: Symbol('UiStore'),
  LogService: Symbol('LogService'),
  ColumnsStore: Symbol('ColumnsStore'),
  AutosaveStore: Symbol('AutosaveStore'),
  SecondSourceService: Symbol('SecondSourceService'),
  SnackbarStore: Symbol('SnackbarStore'),
  ClipboardService: Symbol('ClipboardService'),
  CustomerCSVConfigurationService: Symbol('CustomerCSVConfigurationService'),
  CustomerCSVConfigurationStore: Symbol('CustomerCSVConfigurationStore'),
  FilterStore: Symbol('FilterStore'),
};
